var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicationPillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6375 19.8625C5.72917 20.9542 7.05833 21.5 8.625 21.5C9.375 21.5 10.0917 21.3583 10.775 21.075C11.4583 20.7917 12.0667 20.3833 12.6 19.85L19.35 13.1C19.8833 12.5667 20.2917 11.9583 20.575 11.275C20.8583 10.5917 21 9.875 21 9.125C21 7.55833 20.4542 6.22917 19.3625 5.1375C18.2708 4.04583 16.9417 3.5 15.375 3.5C14.625 3.5 13.9083 3.64167 13.225 3.925C12.5417 4.20833 11.9333 4.61667 11.4 5.15L4.65 11.9C4.11667 12.4333 3.70833 13.0417 3.425 13.725C3.14167 14.4083 3 15.125 3 15.875C3 17.4417 3.54583 18.7708 4.6375 19.8625ZM10.025 19.225C9.575 19.4083 9.10833 19.5 8.625 19.5C7.625 19.5 6.77083 19.1458 6.0625 18.4375C5.35417 17.7292 5 16.875 5 15.875C5 15.3917 5.09167 14.925 5.275 14.475C5.45833 14.025 5.71667 13.6333 6.05 13.3L9 10.375L14.125 15.5L11.2 18.45C10.8667 18.7833 10.475 19.0417 10.025 19.225Z",
    fill: "#087A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicationPillIcon);
export default __webpack_public_path__ + "static/media/medication-pill-icon.3d6432e215fd7a97fd7d7a24093e7363.svg";
export { ForwardRef as ReactComponent };